import api from "./axios";

export const get_subscription_plansApi = (activeOnly = false) => {
    return api.get("/admin/billing/plans/", {
        params: { active_only: activeOnly },
    });
};

export const get_subscription_planApi = (planId) => {
    return api.get(`/admin/billing/plans/${planId}`);
};

export const create_subscription_planApi = (payload) => {
    return api.post("/admin/billing/plans/", payload);
};

export const update_subscription_planApi = (planId, payload) => {
    return api.put(`/admin/billing/plans/${planId}`, payload);
};

export const deactivate_subscription_planApi = (planId) => {
    return api.delete(`/admin/billing/plans/${planId}`);
};

export const get_subscription_plan_metadataApi = () => {
    return api.get("/admin/billing/plans/metadata/features");
};

export const list_user_subscriptionsApi = (params = {}) => {
    return api.get("/admin/billing/user-subscriptions/", { params });
};

export const get_user_subscriptionApi = (userId) => {
    return api.get(`/admin/billing/user-subscriptions/user/${userId}`);
};

export const assign_user_subscriptionApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/assign", payload);
};

export const cancel_user_subscriptionApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/cancel", payload);
};

export const update_user_subscription_quotaApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/quota", payload);
};

export const renew_user_subscriptionApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/renew", payload);
};

export const list_billing_audit_logsApi = (params = {}) => {
    return api.get("/admin/billing/user-subscriptions/audit-logs", { params });
};

export const run_billing_cronApi = () => {
    return api.post("/admin/billing/user-subscriptions/run-billing-cron");
};

export const get_billing_cron_statusApi = () => {
    return api.get("/admin/billing/user-subscriptions/billing-cron/status");
};

export const get_billing_cron_healthApi = () => {
    return api.get("/admin/billing/user-subscriptions/billing-cron/health");
};

export const list_billing_cron_runsApi = (params = {}) => {
    return api.get("/admin/billing/user-subscriptions/billing-cron/runs", { params });
};

export const get_billing_metricsApi = (periodDays = 30) => {
    return api.get("/admin/billing/user-subscriptions/metrics", {
        params: { period_days: periodDays },
    });
};

export const get_billing_kpi_snapshotsApi = (limit = 90) => {
    return api.get("/admin/billing/user-subscriptions/metrics/snapshots", {
        params: { limit },
    });
};

export const get_billing_metric_definitionsApi = () => {
    return api.get("/admin/billing/user-subscriptions/metrics/definitions");
};

export const refund_paymentApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/refund", payload);
};

export const resolve_billing_disputeApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/resolve-dispute", payload);
};

export const list_chargebacksApi = (params = {}) => {
    return api.get("/admin/billing/user-subscriptions/chargebacks", { params });
};

export const create_enterprise_subscriptionApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/enterprise/create", payload);
};

export const activate_enterprise_subscriptionApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/enterprise/activate", payload);
};

export const list_polars_quota_requestsApi = (params = {}) => {
    return api.get("/admin/billing/polars-quota-requests/", { params });
};

export const approve_polars_quota_requestApi = (payload) => {
    return api.post("/admin/billing/polars-quota-requests/approve", payload);
};

export const reject_polars_quota_requestApi = (payload) => {
    return api.post("/admin/billing/polars-quota-requests/reject", payload);
};
